// VapiWidgetComponent.js
import React from "react";
import "@vapi-ai/web"; // registers <vapi-widget> globally

export default function VapiWidgetComponent() {
  return (
    <vapi-widget id="ava-chat"
      public-key="ad257900-e9cf-4f70-b188-9cfc35ea1efc"
      assistant-id="52f5b1d8-5dda-45a9-9b33-aa386dd4f89d"
      mode="chat"
      theme="dark"
      base-bg-color="#000000"
      accent-color="#1e90ff"
      cta-button-color="#000000"
      cta-button-text-color="#ffffff"
      border-radius="medium"
      size="compact"
      position="bottom-right"
      title="CHAT WITH AVA"
      start-button-text="Start"
      chat-first-message="Hey, I'm Ava - NeuroStudio's AI Receptionist. How can I help you today?"
      chat-placeholder="Type your message..."
      float="true"
      consent-required="true"
      consent-title="Terms and conditions"
      consent-content="By clicking 'Agree,' and each time I interact with this AI agent, I consent to the recording, storage, and sharing of my communications with third-party service providers, and as otherwise described in our Terms of Service."
      consent-storage-key="vapi_widget_consent"
    ></vapi-widget>
  );
}